import omit from 'lodash/omit';

import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

export const setDescriptionForIri =
  (iri: string, description: string) => (model: Model) => {
    setDataProperty<ModelData>(model)(model.modelData, 'descriptionsByIri', {
      ...model.modelData.descriptionsByIri,
      [iri]: description,
    });
  };

export const removeDescriptionForIri = (iri: string) => (model: Model) => {
  if (model.modelData.descriptionsByIri[iri] !== undefined) {
    setDataProperty<ModelData>(model)(
      model.modelData,
      'descriptionsByIri',
      omit(model.modelData.descriptionsByIri, iri)
    );
  }
};
